import React from 'react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const FOOTER_WHATSAPP_MESSAGE = 'Hola, equipo de ORIGEN. Quiero conocer más sobre sus servicios digitales.';
const servicesLinks = [{
  href: '#servicios',
  label: 'Presencia Digital'
}, {
  href: '#precios',
  label: 'Automatización'
}, {
  href: '#servicios',
  label: 'Presencia Digital Completa'
}, {
  href: '#voice',
  label: 'VOICE'
}];
const origenLinks = [{
  href: '#como-funciona',
  label: 'Cómo funciona'
}, {
  href: '#aplicaciones',
  label: 'Aplicaciones'
}, {
  href: '#precios',
  label: 'Precios'
}];
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-16 pb-12 md:pb-16" data-id="element-13" data-mp="3ldu2qoshwdu8">
      <div className="max-w-[1240px] mx-auto" data-id="element-14" data-mp="3qc445h4tcaoa">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-15" data-mp="29z6uqczdolgf">
          {/* Left Column */}
          <div className="flex-1" data-id="element-16" data-mp="2eyjrpqjyr8wq">
            <div className="mb-4" data-id="element-17" data-mp="2ezutxlxrg8lq">
              <Logo variant="dark" data-id="element-18" data-mp="3l9k6xg5ljtev" />
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-19" data-mp="3labt60db0esh">
              Sistemas digitales para empresas.
            </p>
          </div>

          {/* Link Columns */}
          <div className="flex-1 md:max-w-[480px] grid grid-cols-3 gap-8" data-id="element-20" data-mp="3v9az3b6opwbs">
            <div data-id="element-21" data-mp="3q7lmvs7q7cm4">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-22" data-mp="3q725cclzmq8m">
                SERVICIOS
              </span>
              <div className="flex flex-col gap-3" data-id="element-23" data-mp="3477xwrgsq3h">
                {servicesLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena transition-colors duration-150 no-underline" data-id="element-24" data-mp="htd1b43mfm3g">
                    {link.label}
                  </a>)}
              </div>
            </div>
            <div data-id="element-25" data-mp="mtr9qn94wy20">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-26" data-mp="mq3hrsjc8jpe">
                ORIGEN
              </span>
              <div className="flex flex-col gap-3" data-id="element-27" data-mp="yv917kirlkrj">
                {origenLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena transition-colors duration-150 no-underline" data-id="element-28" data-mp="13s981xnfurjp">
                    {link.label}
                  </a>)}
                <a href={getWhatsAppLink(FOOTER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena transition-colors duration-150 no-underline" data-id="element-29" data-mp="1hj4bguf64gfw">
                  Contacto
                </a>
              </div>
            </div>
            <div data-id="element-30" data-mp="3tb1bs5hz4ym9">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-31" data-mp="3tahyx376l0f3">
                LEGAL
              </span>
              <div className="flex flex-col gap-3" data-id="element-32" data-mp="25o58ygmttnbm">
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-33" data-mp="25maot4jdpz8l">
                  Privacidad
                </span>
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-34" data-mp="1wo8pquj7hgny">
                  Términos
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-35" data-mp="2pdpeni7mafff">
          <p className="font-body text-[12px] text-arena/30" data-id="element-36" data-mp="2kd1dw4tl6k80">
            © 2026 ORIGEN · Colombia
          </p>
        </div>
      </div>
    </footer>;
}